import { useEffect } from 'react';
import { generateSitemapEntries } from '../utils/seoUtils';

const SitemapGenerator = () => {
  useEffect(() => {
    // Generate and expose sitemap data for server-side rendering or static generation
    const sitemapEntries = generateSitemapEntries();
    
    // Make sitemap data available globally for build processes
    window.CONSTRUCTION_COST_SITEMAP = sitemapEntries;
    
    // Create XML sitemap content
    const sitemapXml = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  <url>
    <loc>https://costtoconstruct.com/</loc>
    <lastmod>${new Date().toISOString().split('T')[0]}</lastmod>
    <changefreq>daily</changefreq>
    <priority>1.0</priority>
  </url>
  <url>
    <loc>https://costtoconstruct.com/conceptual-estimate</loc>
    <lastmod>${new Date().toISOString().split('T')[0]}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.9</priority>
  </url>
  ${sitemapEntries.map(entry => `
  <url>
    <loc>${entry.url}</loc>
    <lastmod>${entry.lastmod}</lastmod>
    <changefreq>${entry.changefreq}</changefreq>
    <priority>${entry.priority}</priority>
  </url>`).join('')}
</urlset>`;

    // Store sitemap XML for potential download or server use
    window.CONSTRUCTION_COST_SITEMAP_XML = sitemapXml;
    
    console.log(`Generated sitemap with ${sitemapEntries.length} SEO-optimized URLs`);
  }, []);

  return null; // This is a utility component, no UI needed
};

export default SitemapGenerator;
